import { HiSpeakerphone } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
export default function TopTicker({ text = [], onclose }) {

    if (text.length === 0) return null
    const duplicateCount = text.length === 1 ? 8 : 3;
    const allMessages = Array(duplicateCount).fill(text).flat();
    return (

        <div className="ticker-container">
            <HiSpeakerphone className="ticker-icon" />

            <div className="ticker-text">
                <div className="ticker-scroll">
                    {allMessages.map((msg, index) => (
                        <span key={`msg-${index}`} className="ticker-item">{msg}</span>
                    ))}
                </div>
            </div>

            <button
                className="ticker-close"
                onClick={onclose}
                aria-label="Close ticker"
            >
                <IoClose size={18} />
            </button>

            <style>{`
      .ticker-container {
    position: sticky;
    top: 0;
    left: 0;
    // width: 100%;
    height: 30px;
    background: #f7ebe9;
    color: #B83D3D;
    display: flex;
    align-items: center;
    padding: 0 14px;
    z-index: 9999;
    font-size: 11px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.ticker-icon {
    color: #facc15;
    margin-right: 10px;
    flex-shrink: 0;
    font-size: 18px;
}

.ticker-text {
    overflow: hidden;
    flex: 1;
    position: relative;
    mask-image: linear-gradient(
        to right,
        transparent,
        black 5%,
        black 95%,
        transparent
    );
    -webkit-mask-image: linear-gradient(
        to right,
        transparent,
        black 5%,
        black 95%,
        transparent
    );
}

.ticker-scroll {
    display: inline-flex;
    white-space: nowrap;
    animation: scroll-left 100s linear infinite;
    will-change: transform;
}

.ticker-item {
    display: inline-block;
    padding: 0 30px;
    white-space: nowrap;
    font-weight: 550;
}

/* Smooth continuous scrolling from right to left */
@keyframes scroll-left {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(-50%);
    }
}

.ticker-close {
    background: transparent;
    border: none;
    color: #B83D3D;
    cursor: pointer;
    margin-left: 12px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s;
    flex-shrink: 0;
}

.ticker-close:hover {
    color: #f87171;
    background: rgba(248, 113, 113, 0.1);
}

/* Pause animation on hover */
.ticker-container:hover .ticker-scroll {
    animation-play-state: paused;
}
      `}</style>
        </div>
    );
}